<template>
  <v-row justify="center">
    <v-dialog v-model="active" max-width="500">
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="top: 22px">
          <v-icon color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          {{title}}
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; height:80px; font-size:15px">
          {{content}}
        </v-card-text>
        <v-card-actions class="mb-2 px-3" style="justify-content:center">
          <v-btn class="colorBtn" outlined color="#FFF" @click="close">
            {{$t('__cancel')}}
          </v-btn>
          <v-btn class="colorBtn primary-color-background" outlined color="#FFF" @click="save">
            {{$t('__s3Delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import i18n from '../plugins/i18n'
  export default {
    name:'DeleteConfirm',
    props:['onSave'],
    data () {
      return {
        active: false,
        title: '',
        content: '',
        onSaveEn: false,
        info: '',
      }
    },
    methods:{
      open(type = null, title = null, content = null, onSaveEn = false, info = null){
        this.active = true
        this.onSaveEn = onSaveEn
        this.info = info
        switch(type){
          case 0:
          default:
            this.title = title
            this.content = content
            break
          case 1:
            this.title = i18n.t('__s3Delete')
            this.content = i18n.t('__s3DeleteBindConfirm')
            break
        }
      },
      close(){
        this.active = false
      },
      save(){
        if(this.onSaveEn){
          this.onSave(this.info)
        }
        this.close()
      }
    }
  }
</script>